import type { ReactNode } from 'react'

export function SidebarWrap(props: { children: ReactNode; folded?: boolean }) {
  return (
    <aside
      className='custom-scroll-bar grid-in-sidebar sticky top-0 h-screen overflow-auto bg-base-2 p-4 pt-0 pr-4 data-[folded=true]:overflow-hidden'
      data-folded={props.folded}
    >
      {props.children}
    </aside>
  )
}
